<template>
  <section class="testimonials-section">
    <div class="container">
      <div class="inner-section">
        <div>
          <h1 class="title">
            "During my quest for new opportunities, I stumbled upon Proxify.
            Little did I know that these three months of anticipation would be a
            transformative learning curve."
          </h1>
          <div class="member">
            <span class="member-name">Temo K.</span>
            <span class="member-role">Fullstack Developer</span>
          </div>
          <nuxt-link to="/journal?category=developer-success">
            <span
              class="link"
              @click="trackEvent"
            >
              see more stories
            </span>
          </nuxt-link>
        </div>
        <div>
          <NuxtPicture
            class="member-image"
            src="/images/lead-gen-page/testimonials/member.png"
            alt="Temo K."
            lazy
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    trackEvent() {
      this.$analytics.track('CTA Clicked', {
        cta_name: 'See more stories',
        section: 'Testimonials',
        page_name: 'Lead gen page v1',
      });
    },
  },
};
</script>

<style lang="scss" src="./Testimonials.scss" scoped />
